import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { expandSection, toggleSection } from './AccordionActions';
import Col from '../../../shared-components/VXGrid/Col';
import Row from '../../../shared-components/VXGrid/Row';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import _ from 'lodash';
import './AccordionSection.less';

export class AccordionSection extends Component {

    static propTypes = {
        toggleSection: PropTypes.func.isRequired,
        expandSection: PropTypes.func.isRequired,
        isExpanded: PropTypes.bool,

        // Passed in props
        id: PropTypes.string.isRequired,
        children: PropTypes.node,
        className: PropTypes.string,
        extraTitle: PropTypes.node,
        title: PropTypes.node.isRequired,
        conditionToExpand: PropTypes.bool
    };

    static defaultProps = {
        isExpanded: false
    };

    static getDerivedStateFromProps(props, state) {
        if (props.conditionToExpand && !state.hasAlreadyAutoExpanded) {
            // dispatch expansion event
            const { id, expandSection } = props;
            expandSection(id);

            return {
                hasAlreadyAutoExpanded: true
            };
        }
        return null; // no change
    }

    constructor(props) {
        super(props);
        this.state = {
            hasAlreadyAutoExpanded: false
        };
    }

    handleToggle = () => {
        const { id, toggleSection } = this.props;
        toggleSection(id);
    };

    render() {
        const {
            children,
            className,
            extraTitle,
            title,
            isExpanded
        } = this.props;

        const defaultClasses = `${className ? className + ' ' : ''}AccordionSection collapsible`;

        return (
            <div className={`${defaultClasses}${isExpanded ? '' : ' collapsed'}`}>
                <Row gutterSize={10}>
                    <Col xs={12}>
                        <Button
                            data-automation-id="accordion"
                            btnStyle={BUTTON_STYLE.UNSTYLED}
                            className="AccordionSection-header"
                            onClick={this.handleToggle}
                            aria-expanded={`${isExpanded ? true : false}`}
                        >
                            <h3 className="vx_text-3_lighter border-top">
                                {title}
                                {extraTitle}
                                <span className="expand-collapse-action" />
                            </h3>
                        </Button>
                        <div className="collapsible-content">
                            {children}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export const mapStateToProps = (state, ownProps) => ({
    isExpanded: _.get(state, ['accordion', 'sections', ownProps.id, 'isExpanded'])
});

export const mapDispatchToProps = dispatch => ({
    toggleSection(id) {
        dispatch(toggleSection(id));
    },
    expandSection(id) {
        dispatch(expandSection(id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AccordionSection);
